(function() {
  
  const colorMapping = {
'Beere / Rosa - Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Beere / Rosa / Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Beere / Rosa - Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Beere / Rosa / Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Beere / Rosa': ['Rosa Mix / Silber', 'Rose Gold', 'Rosa'],
'Beige / Blau - Gold': ['Blau Mix / Gold', 'Gold', 'Blau'],
'Beige / Blau / Gold': ['Blau Mix / Gold', 'Gold', 'Blau'],
'Beige / Blau - Silber': ['Blau Mix / Silber', 'Silber', 'Blau'],
'Beige / Blau / Silber': ['Blau Mix /Silber', 'Silber', 'Blau'],
'Beige / Blau': ['Blau Mix / Silber', 'Silber', 'Blau'],
'Beige / Braun - Gold': ['Leo / Schwarz / Gold', 'Gold', 'Schwarz'],
'Beige / Braun / Gold': ['Leo / Schwarz / Gold', 'Gold', 'Schwarz'],
'Beige / Braun - Silber': ['Leo / Schwarz / Silber', 'Silber', 'Schwarz'],
'Beige / Braun / Silber': ['Leo / Schwarz / Silber', 'Silber', 'Schwarz'],
'Beige / Braun': ['Leo / Schwarz / Silber', 'Gold', 'Schwarz'],
'Blau / Weiß - Gold': ['Beige / Blau / Gold', 'Gold', 'Blau'],
'Blau / Weiß / Gold': ['Beige / Blau / Gold', 'Gold', 'Blau'],
'Blau / Weiß - Silber': ['Beige / Blau / Silber', 'Silber', 'Blau'],
'Blau / Weiß / Silber': ['Beige / Blau / Silber', 'Silber', 'Blau'],
'Blau / Weiß': ['Beige / Blau / Silber', 'Gold', 'Blau'],
'Braun - Gold': ['Braun / Taupe Mix / Gold', 'Gold', 'Schwarz'],
'Braun / Gold': ['Braun / Taupe Mix / Gold', 'Gold', 'Schwarz'],
'Braun - Silber': ['Braun / Taupe Mix / Silber', 'Silber', 'Schwarz'],
'Braun / Silber': ['Braun / Taupe Mix / Silber', 'Silber', 'Schwarz'],
'Braun': ['Braun / Taupe Mix / Silber', 'Gold', 'Schwarz'],
'Grau / Schwarz - Gold': ['Grau Camouflage / Gold', 'Gold', 'Schwarz'],
'Grau / Schwarz / Gold': ['Grau Camouflage / Gold', 'Gold', 'Schwarz'],
'Grau / Schwarz - Silber': ['Grau Camouflage / Silber', 'Silber', 'Schwarz'],
'Grau / Schwarz / Silber': ['Grau Camouflage / Silber', 'Silber', 'Schwarz'],
'Grau / Schwarz': ['Grau Camouflage / Silber', 'Grau', 'Schwarz'],
'Grün / Beige - Gold': ['Grün Mix / Gold', 'Gold', 'Nachtgrün'],
'Grün / Beige / Gold': ['Grün Mix / Gold', 'Gold', 'Nachtgrün'],
'Grün / Beige - Silber': ['Grün Mix / Silber', 'Silber', 'Nachtgrün'],
'Grün / Beige / Silber': ['Grün Mix / Silber', 'Silber', 'Nachtgrün'],
'Grün / Beige': ['Grün Mix / Silber', 'Gold', 'Nachtgrün'],
'Grün / Schwarz - Gold': ['Dunkelgrün Camouflage / Gold', 'Gold', 'Schwarz'],
'Grün / Schwarz / Gold': ['Dunkelgrün Camouflage / Gold', 'Gold', 'Schwarz'],
'Grün / Schwarz - Silber': ['Dunkelgrün Camouflage / Silber', 'Silber', 'Schwarz'],
'Grün / Schwarz / Silber': ['Dunkelgrün Camouflage / Silber', 'Silber', 'Schwarz'],
'Grün / Schwarz': ['Dunkelgrün Camouflage / Silber', 'Grau', 'Schwarz'],
'Hellblau / Rot - Gold': ['Braun / Taupe Mix / Gold', 'Gold', 'Rot'],
'Hellblau / Rot / Gold': ['Braun / Taupe Mix / Gold', 'Gold', 'Rot'],
'Hellblau / Rot - Silber': ['Braun / Taupe Mix / Silber', 'Silber', 'Rot'],
'Hellblau / Rot / Silber': ['Braun / Taupe Mix / Silber', 'Silber', 'Rot'],
'Hellblau / Rot': ['Braun / Taupe Mix / Silber', 'Gold', 'Rot'],
'Hellbraun / Braun - Gold': ['Braun / Gold', 'Gold', 'Schwarz'],
'Hellbraun / Braun / Gold': ['Braun / Gold', 'Gold', 'Schwarz'],
'Hellbraun / Braun - Silber': ['Braun / Silber', 'Silber', 'Schwarz'],
'Hellbraun / Braun / Silber': ['Braun / Silber', 'Silber', 'Schwarz'],
'Hellbraun / Braun': ['Braun / Silber', 'Gold', 'Schwarz'],
'Leo / Schwarz - Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo / Schwarz / Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo / Schwarz - Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo / Schwarz / Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo / Schwarz': ['Zebra / Beige / Silber', 'Gold', 'Schwarz'],
'Lila / Grün - Gold': ['Grün Mix / Gold', 'Gold', 'Lila'],
'Lila / Grün / Gold': ['Grün Mix / Gold', 'Gold', 'Lila'],
'Lila / Grün - Silber': ['Grün Mix / Silber', 'Silber', 'Lila'],
'Lila / Grün / Silber': ['Grün Mix / Silber', 'Silber', 'Lila'],
'Lila / Grün': ['Grün Mix / Silber', 'Grau', 'Lila'],
'Orange / Grün - Gold': ['Beige / Braun / Gold', 'Gold', 'Schwarz'],
'Orange / Grün / Gold': ['Beige / Braun / Gold', 'Gold', 'Schwarz'],
'Orange / Grün - Silber': ['Beige / Braun / Silber', 'Silber', 'Schwarz'],
'Orange / Grün / Silber': ['Beige / Braun / Silber', 'Silber', 'Schwarz'],
'Orange / Grün': ['Beige / Braun', 'Gold', 'Schwarz'],
'Pink / Blau - Gold': ['Beere / Gold', 'Gold', 'Pink'],
'Pink / Blau / Gold': ['Beere / Gold', 'Gold', 'Pink'],
'Pink / Blau - Silber': ['Beere / Silber', 'Silber', 'Pink'],
'Pink / Blau / Silber': ['Beere / Silber', 'Silber', 'Pink'],
'Pink / Blau': ['Beere / Silber', 'Silber', 'Pink'],
'Rot / Braun - Gold': ['Beige / Braun / Gold', 'Gold', 'Schwarz'],
'Rot / Braun / Gold': ['Beige / Braun / Gold', 'Gold', 'Schwarz'],
'Rot / Braun - Silber': ['Beige / Braun / Silber', 'Silber', 'Schwarz'],
'Rot / Braun / Silber': ['Beige / Braun / Silber', 'Silber', 'Schwarz'],
'Rot / Braun': ['Beige / Braun / Silber', 'Gold', 'Schwarz'],
'Zebra / Beige - Gold': ['Leo / Beige / Gold', 'Gold', 'Schwarz'],
'Zebra / Beige / Gold': ['Leo / Beige / Gold', 'Gold', 'Schwarz'],
'Zebra / Beige - Silber': ['Leo / Beige / Silber', 'Silber', 'Schwarz'],
'Zebra / Beige / Silber': ['Leo / Beige / Silber', 'Silber', 'Schwarz'],
'Zebra / Beige': ['Leo / Beige / Silber', 'Gold', 'Schwarz'],
'Leo / Beige - Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo / Beige / Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo / Beige - Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo / Beige / Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo / Beige': ['Zebra / Beige / Silber', 'Gold', 'Schwarz'],
'Grau Camouflage - Gold': ['Grau / Schwarz Mix / Gold', 'Gold', 'Schwarz'],
'Grau Camouflage / Gold': ['Grau / Schwarz Mix / Gold', 'Gold', 'Schwarz'],
'Grau Camouflage - Silber': ['Grau / Schwarz Mix / Silber', 'Silber', 'Schwarz'],
'Grau Camouflage / Silber': ['Grau / Schwarz Mix / Silber', 'Silber', 'Schwarz'],
'Grau Camouflage': ['Grau / Schwarz Mix / Silber', 'Silber', 'Schwarz'],
'Dunkelgrün Camouflage - Gold': ['Grün / Schwarz / Gold', 'Gold', 'Schwarz'],
'Dunkelgrün Camouflage / Gold': ['Grün / Schwarz / Gold', 'Gold', 'Schwarz'],
'Dunkelgrün Camouflage - Silber': ['Grün / Schwarz / Silber', 'Silber', 'Schwarz'],
'Dunkelgrün Camouflage / Silber': ['Grün / Schwarz / Silber', 'Silber', 'Schwarz'],
'Dunkelgrün Camouflage': ['Grün / Schwarz / Silber', 'Silber', 'Schwarz'],
'Rosa Camouflage - Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Rosa Camouflage / Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Rosa Camouflage - Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Rosa Camouflage / Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Rosa Camouflage': ['Rosa Mix / Silber', 'Rose Gold', 'Rosa'],
'Einhorn - Gold': ['Helllila / Grün / Gold', 'Gold', 'Lila'],
'Einhorn / Gold': ['Helllila / Grün / Gold', 'Gold', 'Lila'],
'Einhorn - Silber': ['Helllila / Grün / Silber', 'Silber', 'Lila'],
'Einhorn / Silber': ['Helllila / Grün / Silber', 'Silber', 'Lila'],
'Einhorn': ['Helllila / Grün / Silber', 'Silber', 'Lila'],
'Blau Mix - Gold': ['Blau / Weiß / Gold', 'Gold', 'Blau'],
'Blau Mix / Gold': ['Blau / Weiß / Gold', 'Gold', 'Blau'],
'Blau Mix -Silber': ['Blau / Weiß / Silber', 'Silber', 'Blau'],
'Blau Mix /Silber': ['Blau / Weiß / Silber', 'Silber', 'Blau'],
'Blau Mix': ['Blau / Weiß / Silber', 'Silber', 'Blau'],
'Grau / Schwarz Mix - Gold': ['Grau / Schwarz / Gold', 'Gold', 'Schwarz'],
'Grau / Schwarz Mix / Gold': ['Grau / Schwarz / Gold', 'Gold', 'Schwarz'],
'Grau / Schwarz Mix - Silber': ['Grau / Schwarz / Silber', 'Silber', 'Schwarz'],
'Grau / Schwarz Mix / Silber': ['Grau / Schwarz / Silber', 'Silber', 'Schwarz'],
'Grau / Schwarz Mix': ['Grau / Schwarz / Silber', 'Grau', 'Schwarz'],
'Grün Mix - Gold': ['Grün / Schwarz / Gold', 'Gold', 'Schwarz'],
'Grün Mix / Gold': ['Grün / Schwarz / Gold', 'Gold', 'Schwarz'],
'Grün Mix - Silber': ['Grün / Schwarz / Silber', 'Silber', 'Schwarz'],
'Grün Mix / Silber': ['Grün / Schwarz / Silber', 'Silber', 'Schwarz'],
'Grün Mix': ['Grün / Schwarz / Silber', 'Grau', 'Schwarz'],
'Mint / Rosa Mix - Gold': ['Taupe Camouflage / Gold', 'Gold', 'Rosa'],
'Mint / Rosa Mix / Gold': ['Taupe Camouflage / Gold', 'Gold', 'Rosa'],
'Mint / Rosa Mix - Silber': ['Taupe Camouflage / Silber', 'Silber', 'Rosa'],
'Mint / Rosa Mix / Silber': ['Taupe Camouflage / Silber', 'Silber', 'Rosa'],
'Mint / Rosa Mix': ['Taupe Camouflage / Silber', 'Gold', 'Rosa'],
'Rosa Mix - Gold': ['Rosa Camouflage / Gold', 'Gold', 'Rosa'],
'Rosa Mix / Gold': ['Rosa Camouflage / Gold', 'Gold', 'Rosa'],
'Rosa Mix - Silber': ['Rosa Camouflage / Silber', 'Silber', 'Rosa'],
'Rosa Mix / Silber': ['Rosa Camouflage / Silber', 'Silber', 'Rosa'],
'Rosa Mix': ['Rosa Camouflage / Silber', 'Rose Gold', 'Rosa'],
'Pink Mix - Gold': ['Beere / Gold', 'Gold', 'Pink'],
'Pink Mix / Gold': ['Beere / Gold', 'Gold', 'Pink'],
'Pink Mix - Silber': ['Beere / Silber', 'Silber', 'Pink'],
'Pink Mix / Silber': ['Beere / Silber', 'Silber', 'Pink'],
'Pink Mix': ['Beere / Silber', 'Silber', 'Pink'],
'Braun / Taupe Mix - Gold': ['Braun / Gold', 'Gold', 'Schwarz'],
'Braun / Taupe Mix / Gold': ['Braun / Gold', 'Gold', 'Schwarz'],
'Braun / Taupe Mix - Silber': ['Braun / Silber', 'Silber', 'Schwarz'],
'Braun / Taupe Mix / Silber': ['Braun / Silber', 'Silber', 'Schwarz'],
'Braun / Taupe Mix': ['Braun / Silber', 'Gold', 'Schwarz'],
'Dunkelgrau / Schwarz - Gold': ['Grau Camouflage / Gold', 'Gold', 'Schwarz'],
'Dunkelgrau / Schwarz / Gold': ['Grau Camouflage / Gold', 'Gold', 'Schwarz'],
'Dunkelgrau / Schwarz - Silber': ['Grau Camouflage / Silber', 'Silber', 'Schwarz'],
'Dunkelgrau / Schwarz / Silber': ['Grau Camouflage / Silber', 'Silber', 'Schwarz'],
'Dunkelgrau / Schwarz': ['Grau Camouflage / Silber', 'Grau', 'Schwarz'],
'Regenbogen - Gold': ['Rot / Braun / Gold', 'Gold', 'Rot'],
'Regenbogen / Gold': ['Rot / Braun / Gold', 'Gold', 'Rot'],
'Regenbogen - Silber': ['Rot / Braun / Silber', 'Silber', 'Rot'],
'Regenbogen / Silber': ['Rot / Braun / Silber', 'Silber', 'Rot'],
'Regenbogen': ['Rot / Braun / Silber', 'Gold', 'Rot'],
'Beere - Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Beere / Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Beere - Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Beere / Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Beere': ['Rosa Mix / Silber', 'Bordeaux Rot Clips Silber', 'Rose Gold', 'Rosa'],
'Grün Camouflage - Gold': ['Dunkelgrün Camouflage / Gold', 'Gold', 'Schwarz'],
'Grün Camouflage / Gold': ['Dunkelgrün Camouflage / Gold', 'Gold', 'Schwarz'],
'Grün Camouflage - Silber': ['Dunkelgrün Camouflage / Silber', 'Silber', 'Schwarz'],
'Grün Camouflage / Silber': ['Dunkelgrün Camouflage / Silber', 'Silber', 'Schwarz'],
'Grün Camouflage': ['Dunkelgrün Camouflage / Silber', 'Grau', 'Schwarz'],
'Taupe Camouflage - Gold': ['Leo / Schwarz / Gold', 'Gold', 'Schwarz'],
'Taupe Camouflage / Gold': ['Leo / Schwarz / Gold', 'Gold', 'Schwarz'],
'Taupe Camouflage - Silber': ['Leo / Schwarz / Silber', 'Silber', 'Schwarz'],
'Taupe Camouflage / Silber': ['Leo / Schwarz / Silber', 'Silber', 'Schwarz'],
'Taupe Camouflage': ['Leo / Schwarz / Silber', 'Gold', 'Schwarz'],
'Zebra / Taupe / Gold': ['Leo / Beige / Gold', 'Gold', 'Schwarz'],
'Zebra / Taupe / Silber': ['Leo / Beige / Silber', 'Silber', 'Schwarz'],
'Zebra / Taupe': ['Leo / Beige / Silber', 'Gold', 'Schwarz'],
'Leo / Taupe / Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo / Taupe / Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo / Taupe': ['Zebra / Beige / SIlber', 'Gold', 'Schwarz'],
'Zickzack Grün / Schwarz / Gold': ['Dunkelgrün Camouflage / Gold', 'Gold', 'Nachtgrün'],
'Zickzack Grün / Schwarz / Silber': ['Dunkelgrün Camouflage / Silber', 'Silber', 'Nachtgrün'],
'Zickzack Grün / Schwarz': ['Dunkelgrün Camouflage / Silber ', 'Grau', 'Nachtgrün'],
'Zickzack Hellbraun / Braun / Gold': ['Braun / Gold', 'Gold', 'Schwarz'],
'Zickzack Hellbraun / Braun / Silber': ['Braun / Silber', 'Silber', 'Schwarz'],
'Zickzack Hellbraun / Braun': ['Braun / Silber', 'Gold', 'Schwarz'],
'Zickzack Orange / Grün / Gold': ['Beige / Braun / Gold', 'Gold', 'Schwarz'],
'Zickzack Orange / Grün / Silber': ['Beige / Braun / Silber', 'Silber', 'Schwarz'],
'Zickzack Orange / Grün': ['Beige / Braun / Silber', 'Gold', 'Schwarz'],
'Zickzack Pink / Blau / Gold': ['Beere / Gold', 'Gold', 'Pink'],
'Zickzack Pink / Blau / Silber': ['Beere / Silber', 'Silber', 'Pink'],
'Zickzack Pink / Blau': ['Beere / Silber', 'Gold', 'Pink'],
'Zickzack Rot / Braun / Gold': ['Beige / Braun / Gold', 'Gold', 'Schwarz'],
'Zickzack Rot / Braun / Silber': ['Beige / Braun / Silber', 'Silber', 'Schwarz'],
'Zickzack Rot / Braun': ['Beige / Braun / Silber', 'Gold', 'Schwarz'],
'Zickzack Beere / Rosa / Gold': ['Rosa Mix / Gold', 'Gold', 'Rosa'],
'Zickzack Beere / Rosa / Silber': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Zickzack Beere / Rosa': ['Rosa Mix / Silber', 'Gold', 'Rosa'],
'Zickzack Blau / Weiß / Gold': ['Beige / Blau / Gold', 'Gold', 'Blau'],
'Zickzack Blau / Weiß / Silber': ['Beige / Blau / Silber', 'Silber', 'Blau'],
'Zickzack Blau / Weiß': ['Beige / Blau / Silber', 'Silber', 'Blau'],
'Zickzack Grau / Schwarz / Gold': ['Grau Camouflage / Gold', 'Gold', 'Schwarz'],
'Zickzack Grau / Schwarz / Silber': ['Grau Camouflage / Silber', 'Silber', 'Schwarz'],
'Zickzack Grau / Schwarz': ['Grau Camouflage / Silber', 'Grau', 'Schwarz'],
'Zickzack Hellblau / Rot / Gold': ['Braun / Taupe Mix / Gold', 'Gold', 'Rot'],
'Zickzack Hellblau / Rot / Silber': ['Braun / Taupe Mix / Silber', 'Silber', 'Rot'],
'Zickzack Hellblau / Rot': ['Braun / Taupe Mix / Silber', 'Gold', 'Rot'],
'Zickzack Lila / Grün / Gold': ['Grün Mix / Gold', 'Gold', 'Nachtgrün'],
'Zickzack Lila / Grün / Silber': ['Grün Mix / Silber', 'Silber', 'Nachtgrün'],
'Zickzack Lila / Grün': ['Grün Mix / Silber', 'Gold', 'Nachtgrün'],
'Leo Braun / Schwarz / Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo Braun / Schwarz / Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo Braun / Schwarz': ['Zebra / Beige', 'Gold', 'Schwarz'],
'Leo Taupe / Schwarz / Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo Taupe / Schwarz / Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo Taupe / Schwarz': ['Zebra / Beige', 'Gold', 'Schwarz'],
'Zebra / Gold': ['Leo / Beige / Gold', 'Gold', 'Schwarz'],
'Zebra / Silber': ['Leo / Beige / Silber', 'Silber', 'Schwarz'],
'Zebra': ['Leo / Beige / Silber', 'Gold', 'Schwarz'],
'Braun Wellen / Gold': ['Braun / Taupe Mix / Gold', 'Gold', 'Schwarz'],
'Braun Wellen / Silber': ['Braun / Taupe Mix / Silber', 'Silber', 'Schwarz'],
'Braun Wellen': ['Braun / Taupe Mix', 'Gold', 'Schwarz'],
'Beige Wellen / Gold': ['Leo / Schwarz / Gold', 'Gold', 'Schwarz'],
'Beige Wellen / Silber': ['Leo / Schwarz / Silber', 'Silber', 'Schwarz'],
'Beige Wellen': ['Leo / Schwarz / Silber', 'Gold', 'Schwarz'],
'Blau Wellen / Gold': ['Blau Mix / Gold', 'Gold', 'Blau'],
'Blau Wellen / Silber': ['Blau Mix / Gold', 'Silber', 'Blau'],
'Blau Wellen': ['Blau Mix / Gold', 'Silber', 'Blau'],
'Grün Wellen / Gold': ['Grün Mix / Gold', 'Gold', 'Nachtgrün'],
'Grün Wellen / Silber': ['Grün Mix / Silber', 'Silber', 'Nachtgrün'],
'Grün Wellen': ['Grün Mix / Silber', 'Gold', 'Nachtgrün'],
'Leo / Gold': ['Zebra / Beige / Gold', 'Gold', 'Schwarz'],
'Leo / Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Leo': ['Zebra / Beige / Silber', 'Gold', 'Schwarz'],
'Altrosa': ['Mint / Rosa Mix / Silber', 'Rose-Gold Clips Silber', 'Silber', 'Rosa'],
'Schwarz Clips Silber': ['Zebra / Beige / Silber', 'Silber', 'Schwarz'],
'Blau': ['Blau Mix / Silber', 'Navy Blau Clips Silber', 'Silber', 'Blau'],
'Grau': ['Grau / Schwarz Mix / Silber', 'Schwarz Clips Silber', 'Silber', 'Schwarz'],
'Grün': ['Grün / Beige / Gold', 'Grün Clips Gold', 'Gold', 'Nachtgrün'],
'Pink': ['Pink Mix / Silber', 'Rose-Gold Clips Silber', 'Silber', 'Pink'],
'Rot': ['Beere / Silber', 'Grau Clips Silber', 'Silber', 'Rot'],
'Einhorn Lila / Pink': ['Helllila / Grün / Silber', 'Silber', 'Lila'],
'Regenbogen Grün / Gelb': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Rosa': ['Rosa Mix / Silber', 'Rose-Gold Clips Silber', 'Silber', 'Rosa'],
'Rot Camouflage': ['Beere / Rosa / Gold', 'Gold', 'Schwarz'],
'Weiß / Silber': ['Beige / Blau / Silber', 'Silber', 'Blau'],
'Blau Camouflage': ['Rot / Braun / Silber', 'Silber', 'Blau'],
'Schwarz Camouflage': ['Grau Camouflage / Silber', 'Silber', 'Schwarz'],
'Schwarz Clips Rose': ['Rosa Camouflage / Silber', 'Rose Gold', 'Rosa'],
'Schwarz Clips Schwarz': ['Leo / Beige / Silber', 'Grau', 'Schwarz'],
'Blau Clips Schwarz': ['Blau Mix / Silber', 'Grau', 'Blau'],
'Grau / Schwarz Clips Schwarz': ['Grau Camouflage / Silber', 'Grau', 'Schwarz'],
'Grau / Weiß': ['Grau / Schwarz Mix / Silber', 'Silber', 'Schwarz'],
'Grün Clips Schwarz': ['Grün Mix / Silber', 'Grau', 'Schwarz'],
'Taupe Clips Schwarz': ['Braun / Taupe Mix / Silber', 'Grau', 'Schwarz'],
'Hellgrün Camouflage': ['Grün / Schwarz / Silber', 'Silber', 'Schwarz'],
'Gold': ['Leo / Beige / Gold', 'Rose Gold', 'Schwarz'],
'Rose-Gold': ['Rosa Camouflage / Silber', 'Gold', 'Rosa'],
'Silber': ['Grau Camouflage / Silber', 'Grau', 'Schwarz'],
'Koralle': ['Mint / Rosa Mix / Silber', 'Weiß/Silber Clips Silber', 'Silber', 'Rosa'],
'Lila': ['Einhorn / Gold', 'Einhorn Clips Silber', 'Gold', 'Lila'],
'Schwarz': ['Grau / Schwarz Mix / Silber', 'Schwarz Clips Schwarz', 'Grau', 'Schwarz'],
'Taupe': ['Leo / Beige / Silber', 'Grün Camouflage Clips Gold', 'Silber', 'Schwarz'],
'Hülle Aschblau, Kordel Blau / Schwarz': ['Blau Mix / Silber', 'Silber', 'Blau'],
'Hülle Beere, Kordel Beere meliert': ['Beere / Silber', 'Silber', 'Rosa'],
'Hülle Dunkelgrün, Kordel Grün / Schwarz / Weiß': ['Grün / Schwarz / Silber', 'Silber', 'Nachtgrün'],
'Hülle Grau, Kordel Gelb / Grau': ['Regenbogen / Silber', 'Silber', 'Gelb'],
'Hülle Lila, Kordel Lila / Blau': ['Einhorn / Silber', 'Silber', 'Lila'],
'Hülle Rosa, Kordel Rosa / Beige': ['Mint / Rosa Mix / Silber', 'Silber', 'Rosa'],
'Hülle Schwarz, Kordel Schwarz Bunt': ['Regenbogen / Silber', 'Silber', 'Gelb'],
'Hülle Taupe, Kordel Orange / Blau': ['Hellblau / Rot / Silber', 'Silber', 'Orange'],
'Beere Karabiner Gold': ['Beere / Gold', 'Gold', 'Rosa'],
'Koralle Karabiner Gold': ['Mint / Rosa Mix / Gold', 'Gold', 'Rosa'],
'Lila Karabiner Gold': ['Einhorn / Gold', 'Gold', 'Lila'],
'Nachblau Karabiner Gold': ['Blau Mix / Gold', 'Gold', 'Blau'],
'Piniengrün Karabiner Gold': ['Grün / Schwarz / Gold', 'Gold', 'Nachtgrün'],
'Schwarz Karabiner Silber': ['Grau / Schwarz Mix / Silber', 'Silber', 'Schwarz'],
'Taupe Karabiner Matt Gold': ['Grau Camouflage / Gold', 'Gold', 'Schwarz'],
'Bunt Einhorn': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Rot Bordeaux': ['Rot / Braun / Silber', 'Silber', 'Rot'],
'Blau (Navy)': ['Blau Mix / Silber', 'Silber', 'Blau'],
'Mehrfarbig (Rainbow)': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Mehrfarbig Violett (Unicorn)': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Rosa (Rosé-Gold)': ['Rosa Mix / Silber', 'Silber', 'Rosa'],
'Rot (Bordeaux)': ['Rot / Braun / Silber', 'Silber', 'Rot'],
'Schwarz / Gold': ['Taupe Camouflage / Gold', 'Gold', 'Schwarz'],
'Gelb / Grün Regenbogen': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Lila Rosa Einhorn': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Lila / Rosa (Einhorn)': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Grün / Gelb (Regenbogen)': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Regenbogen (Grün /Gelb)': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Einhorn (Lila / Rosa)': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Navy Blau': ['Blau Mix / Silber', 'Silber', 'Blau'],
'Navy Blau Camouflage': ['Blau / Weiß / Silber', 'Silber', 'Blau'],
'Regenbogen (Gelb / Grün)': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Koralle (Rosa)': ['Beere / Silber', 'Silber', 'Rosa'],
'Gelb / Grün': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Lila / Pink': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Pink / Lila': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Aschblau': ['Blau Mix / Silber', 'Grau', 'Blau'],
'Himbeere': ['Beere / Silber', 'Silber', 'Rosa'],
'Dunkelgrau': ['Dunkelgrau / Schwarz / Silber', 'Grau Clips Silber', 'Grau', 'Schwarz'],
'Schwarz Clips Rosa': ['Rosa Camouflage / Silber', 'Rose Gold', 'Rosa'],
'Beige': ['Orange / Grün', 'Silber', 'Rot'],
'Dunkel Grün': ['Grün / Beige / Gold', 'Gold', 'Grün Clips Gold', 'Nachtgrün'],
'Graubraun / Braun': ['Taupe Clips Schwarz', 'Silber', 'Schwarz'],
'Hellbraun / Beige': ['Grün Camouflage Clips Gold', 'Gold', 'Nachtgrün'],
'Blau Navy': ['Blau Mix / Silber', 'Silber', 'Blau'],
'Bunt Regenbogen': ['Regenbogen / Gold', 'Gold', 'Gelb'],
'Einhorn (Rosa/Lila)': ['Pink Mix / Silber', 'Silber', 'Pink'],
'Rot Burgunder': ['Rot / Braun / Silber', 'Silber', 'Rot'],
'Weiß Silber': ['Grau / Schwarz Mix / Silber', 'Grau', 'Schwarz'],
'Transparent': ['Schwarz Camouflage Clips Silber', 'Schwarz'],
'Hellgrau': ['Grau Clips Silber', 'Schwarz'],
'Blaugrün': ['Schwarz Clips Schwarz', 'Schwarz'],
'Orange': ['Regenbogen Clips Gold', 'Rot'],
'Hellblau': ['Einhorn Clips Silber', 'Lila'],
'Gelb': ['Grün Camouflage Clips Gold', 'Gelb'],
'Eisblau': ['Navy Blau Clips Silber', 'Blau'],
'Mintgrün': ['Weiß/Silber Clips Silber', 'Mintgrün'],
'Hell Lila': ['Einhorn Clips Silber', 'Lila'],
'Nachtgrün': ['Grün Clips Gold', 'Nachtgrün'],
'Petrol': ['Eis Blau Clips Schwarz', 'Blau'],
'Hell Rot': ['Rot Camouflage Clips Gold', 'Schwarz'],
'Dunkelgrün': ['Grün Camouflage Clips Gold', 'Nachtgrün'],
'Flieder': ['Schwarz Clips Schwarz', 'Schwarz'],
'Korall': ['Grau Clips Silber', 'Rot'],
'Lavendel': ['Einhorn Clips Silber', 'Lila'],
'Beige (Taupe)': ['Grün Camouflage Clips Gold', 'Nachtgrün'],
'Grün Petrol': ['Eis Blau Clips Schwarz', 'Blau'],
'Hell Braun': ['Regenbogen Clips Gold', 'Schwarz'],
'Nacht Grün': ['Grün Clips Gold', 'Nachtgrün'],
'Alt Rosa': ['Rose-Gold Clips Silber', 'Rosa'],
'Hell Taupe': ['Grün Camouflage Clips Gold', 'Nachtgrün'],
'Hellbraun': ['Regenbogen Clips Gold', 'Schwarz'],
'Blaugrau': ['Eis Blau Clips Schwarz', 'Blau'],
'Hellgrün': ['Weiß/Silber Clips Silber', 'Nachtgrün'],
'Blau / Grau': ['Eis Blau Clips Schwarz', 'Blau'],
'Ultramarin': ['Navy Blau Clips Silber', 'Blau'],
'Dunkelblau': ['Eis Blau Clips Schwarz', 'Blau'],
'Dunkellila': ['Weiß/Silber Clips Silber', 'Lila'],
'Eisblau / Grau': ['Eis Blau Clips Schwarz', 'Blau'],
'Hell Blau': ['Weiß/Silber Clips Silber', 'Blau'],
'Mint Grün': ['Regenbogen Clips Gold', 'Mintgrün'],
'Nacht Blau': ['Navy Camouflage Clips Silber', 'Blau'],
'Piniengrün': ['Schwarz Clips Silber', 'Schwarz'],
'Rosa Braun': ['Rose-Gold Clips Silber', 'Rosa'],
'Nude': ['Schwarz Clips Schwarz', 'Schwarz'],
'Terrakotta': ['Grau Clips Silber', 'Rot'],
'Rosabraun': ['Rose-Gold Clips Silber', 'Rosa'],
'Weiß': ['Schwarz Camouflage Clips Silber', 'Schwarz'],
'Erde': ['Schwarz Clips Silber', 'Schwarz'],
'Gold Braun': ['Grau Clips Silber', 'Schwarz'],
'Violett': ['Weiß/Silber Clips Silber', 'Lila'],
'Altrosa (Rosé)': ['Rose-Gold Clips Silber', 'Rosa'],
'Dunkel Blau': ['Weiß/Silber Clips Silber', 'Blau'],
'Rose Gold': ['Rose-Gold Clips Silber', 'Rosa'],
'Transparent Matt': ['Schwarz Camouflage Clips Silber', 'Schwarz'],
'Dunkel Rot': ['Rot Camouflage Clips Gold', 'Schwarz'],
'Eis Blau': ['Navy Blau Clips Silber', 'Blau'],
'Nachtblau': ['Navy Blau Clips Silber', 'Blau'],
'Hell Grün': ['Weiß/Silber Clips Silber', 'Mintgrün'],
'Hell Grau': ['Grau Clips Silber', 'Schwarz'],
'Pinien Grün': ['Schwarz Clips Silber', 'Schwarz'],
'Hellrot': ['Grau Clips Silber', 'Rot'],
'Dunkelrot': ['Grau Clips Silber', 'Rot'],
'Dunkel Grau': ['Grau Clips Silber', 'Schwarz']
};

  const DEBUG = false;

  function log(message, data = null) {
    if (!DEBUG) return;
    const timestamp = new Date().toLocaleTimeString();
    console.log(`[${timestamp}] ${message}`, data || '');
  }

  function getPrimaryColor() {
    log('\n🔍 === Suche 1. Option (Farbe) ===');

    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) {
      log('⚠️ Kein variant-picker gefunden');
      return null;
    }

    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length === 0) {
      log('⚠️ Keine fieldsets gefunden');
      return null;
    }

    const firstFieldset = fieldsets[0];
    const selectedRadio = firstFieldset.querySelector('input[type="radio"]:checked');

    if (!selectedRadio) {
      log('⚠️ Keine ausgewählte Farbe im ersten fieldset');
      return null;
    }

    const color = selectedRadio.dataset.optionValue;
    log('✅ 1. Option (Farbe) gefunden:', color);
    return color;
  }

  function getSecondOption() {
    log('\n🔍 === Suche 2. Option (Metallfarbe) ===');

    const variantPicker = document.querySelector('variant-picker');

    if (!variantPicker) {
      log('⚠️ Kein variant-picker gefunden');
      return null;
    }

    const fieldsets = variantPicker.querySelectorAll('fieldset');
    log(`Gefundene fieldsets: ${fieldsets.length}`);

    fieldsets.forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend');
      log(`  Fieldset ${index + 1}: ${legend ? legend.textContent.trim() : 'Kein Legend'}`);
    });

    if (fieldsets.length < 2) {
      log('⚠️ Weniger als 2 fieldsets gefunden - suche nach alternativer Struktur');

      const allRadios = variantPicker.querySelectorAll('input[type="radio"]');
      const radioNames = new Set();
      allRadios.forEach(radio => {
        if (radio.name) radioNames.add(radio.name);
      });

      log(`Gefundene Radio-Gruppen (names): ${Array.from(radioNames).join(', ')}`);

      if (radioNames.size < 2) {
        log('⚠️ Keine zweite Radio-Gruppe gefunden');
        return null;
      }

      const secondGroupName = Array.from(radioNames)[1];
      log(`Verwende zweite Radio-Gruppe: ${secondGroupName}`);

      const selectedRadio = variantPicker.querySelector(`input[type="radio"][name="${secondGroupName}"]:checked`);

      if (!selectedRadio) {
        log('⚠️ Keine ausgewählte Option in zweiter Gruppe');
        return null;
      }

      const secondOption = selectedRadio.dataset.optionValue;
      log('✅ 2. Option gefunden:', secondOption);
      return secondOption;
    }

    const secondFieldset = fieldsets[1];
    const selectedRadio = secondFieldset.querySelector('input[type="radio"]:checked');

    if (!selectedRadio) {
      log('⚠️ Keine ausgewählte Option im zweiten fieldset');
      return null;
    }

    const secondOption = selectedRadio.dataset.optionValue;
    log('✅ 2. Option gefunden:', secondOption);
    return secondOption;
  }

  function buildTargetColors(selectedColor, secondOption) {
    log('\n🔨 === Baue Farbliste ===');
    log('Ausgewählte Farbe:', selectedColor);
    log('2. Option:', secondOption);

    if (!selectedColor) {
      log('⚠️ Keine Hauptfarbe vorhanden');
      return [];
    }

    // 1) Kombi-Key "Farbe / Metall" versuchen
    if (secondOption) {
      const combinedKey = `${selectedColor} / ${secondOption}`;
      if (colorMapping[combinedKey]) {
        log('✅ Kombiniertes Mapping gefunden:', combinedKey);
        return colorMapping[combinedKey];
      }
    }

    // 2) Nur Hauptfarbe
    if (colorMapping[selectedColor]) {
      log('✅ Spezielles Mapping für Hauptfarbe gefunden:', selectedColor);
      return colorMapping[selectedColor];
    }

    // 3) Fallback
    log('ℹ️ Kein Mapping gefunden - verwende nur die ausgewählte Farbe');
    return [selectedColor];
  }

  function updateAddonVariants(targetColors, source) {
    log(`\n🔄 === updateAddonVariants aufgerufen (${source}) ===`);
    log('Zu suchende Farben:', targetColors);

    const addonSelects = document.querySelectorAll('.variant-picker-select');
    log(`📋 Gefundene Addon-Selects: ${addonSelects.length}`);

    if (addonSelects.length === 0) {
      log('⚠️ Keine Addon-Selects gefunden - Abbruch');
      return;
    }

    if (typeof targetColors === 'string') {
      targetColors = [targetColors];
      log('🔄 targetColors von String zu Array konvertiert');
    }

    addonSelects.forEach((select, index) => {
      log(`\n🎯 === Verarbeite Select #${index + 1} ===`);
      log('Select Info:', {
        id: select.id,
        currentValue: select.value,
        checkboxId: select.dataset.checkboxId
      });

      const options = select.querySelectorAll('option');
      log(`📝 Verfügbare Optionen: ${options.length}`);

      options.forEach((opt, i) => {
        log(`\n  === Option ${i + 1} DEBUG ===`);
        log(`  Text: "${opt.textContent.trim()}"`);
        log(`  Value: ${opt.value}`);
        log(`  Disabled: ${opt.disabled}`);
        for (let attr of opt.attributes) {
          if (attr.name.startsWith('data-')) {
            log(`    ${attr.name}: "${attr.value}"`);
          }
        }
      });

      let matched = false;

      for (let targetColor of targetColors) {
        log(`\n  🎨 Suche nach: "${targetColor}"`);

        for (let option of options) {
          const optionText = option.textContent.trim();
          log(`    🔍 Prüfe Option-Text: "${optionText}"`);

          if (optionText === targetColor && option.disabled !== true) {
            log('    ✅ *** MATCH GEFUNDEN! ***');
            log(`    Setze Select auf: "${optionText}" (value: ${option.value})`);

            select.value = option.value;
            matched = true;

            select.dispatchEvent(new Event('change', { bubbles: true }));
            log('    📤 Change-Event dispatched');

            const checkboxId = select.dataset.checkboxId;
            if (checkboxId) {
              const checkbox = document.getElementById(checkboxId);
              if (checkbox) {
                checkbox.dataset.variantId = option.value;
                log(`    ✓ Checkbox aktualisiert: ${checkboxId} -> ${option.value}`);
              } else {
                log(`    ⚠️ Checkbox nicht gefunden: ${checkboxId}`);
              }
            }
            break;
          }
        }

        if (matched) {
          log('  ✅ Match gefunden - Schleife beendet');
          break;
        } else {
          log(`  ❌ "${targetColor}" nicht gefunden, versuche nächste Farbe...`);
        }
      }

      if (!matched) {
        log(`\n  ❌ *** KEIN MATCH gefunden für Select #${index + 1} ***`);
        log('  Versuchte Farben:', targetColors);
      }
    });

    log('\n✅ === updateAddonVariants abgeschlossen ===\n');
  }

  function initColorMapping() {
    log('\n🚀 ========================================');
    log('🚀 === initColorMapping GESTARTET ===');
    log('🚀 ========================================');

    const selectedColor = getPrimaryColor();
    if (!selectedColor) {
      log('⚠️ Keine Hauptfarbe gefunden - Abbruch');
      return;
    }
    log('✓ Ausgewählte Hauptfarbe:', selectedColor);

    const secondOption = getSecondOption();
    const finalTargetColors = buildTargetColors(selectedColor, secondOption);

    setTimeout(() => {
      log('⏱️ Timeout (200ms) abgelaufen - rufe updateAddonVariants auf');
      updateAddonVariants(finalTargetColors, 'INITIAL LOAD');
    }, 200);
  }

  document.addEventListener('change', function(e) {
    const target = e.target;

    if (
      target.type === 'radio' &&
      target.dataset.optionValue &&
      target.closest('variant-picker')
    ) {
      log('\n🎯 ========================================');
      log('🎯 === RADIO CHANGE EVENT ===');
      log('🎯 ========================================');

      const selectedColor = getPrimaryColor();   // immer Feld 1
      const secondOption = getSecondOption();    // immer Feld 2

      log('Aktuelle Hauptfarbe:', selectedColor);
      log('Aktuelle Metallfarbe (2. Option):', secondOption);

      const finalTargetColors = buildTargetColors(selectedColor, secondOption);

      setTimeout(() => {
        log('⏱️ Timeout (100ms) abgelaufen - rufe updateAddonVariants auf');
        updateAddonVariants(finalTargetColors, 'USER CHANGE');
      }, 100);
    }
  }, true);

  if (document.readyState === 'loading') {
    log('📄 DOM lädt noch - warte auf DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', () => {
      log('✅ DOMContentLoaded Event gefeuert');
      initColorMapping();
    });
  } else {
    log('📄 DOM bereits geladen - führe initColorMapping direkt aus');
    initColorMapping();
  }

  setTimeout(() => {
    log('⏱️ Retry Timeout (500ms) - erneuter Versuch initColorMapping');
    initColorMapping();
  }, 500);

  const addonContainer = document.querySelector('.addon-container') || document.body;
  log('👁️ Observer registriert auf:', addonContainer === document.body ? 'body' : '.addon-container');

  const observer = new MutationObserver(function(mutations) {
    let needsInit = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (
          node.nodeType === 1 &&
          (node.classList?.contains('variant-picker-select') ||
           node.querySelector?.('.variant-picker-select'))
        ) {
          log('🔍 MutationObserver: Neuer variant-picker-select erkannt', node);
          needsInit = true;
        }
      });
    });
    if (needsInit) {
      log('🔄 MutationObserver triggert initColorMapping (200ms delay)');
      setTimeout(initColorMapping, 200);
    }
  });

  observer.observe(addonContainer, { childList: true, subtree: true });
  log('✅ MutationObserver aktiv\n');

})();